import { useNavigate } from "react-router-dom";
import { observer } from 'mobx-react';
import { useStores } from 'stores/index';

//@ts-ignore
import { MicroIcon } from '@microui/react-icons';
//@ts-ignore
import { Tooltip, Avatar, Loading } from '@microui/react-ui';

const Listing = () => {
  const { tenantStore } = useStores();
  const navigate = useNavigate();

  if (tenantStore.initing)
    return <Loading size="large" loadingText="Đang tải dữ liệu" />;

  return (
    <div className="flex transition-all p-6 overflow-y-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 3xl:grid-cols-4 gap-5 w-full">
        {
          tenantStore.tenantData.map((e) => {
            return (
              <div key={e.id} className="h-[200px] w-auto shadow-sm-custom bg-white rounded-8 p-[18px] flex flex-col justify-between">
                <div className="flex gap-[10px]">
                  <Avatar
                    onClick={() => navigate(e.id)}
                    size='large'
                    type={'square'}
                    value={e.avatar || e.name}
                    data={{
                      name: e.name,
                      email: e.description
                    }}
                    avatarStyle={{
                      backgroundColor: 'var(--microui-color-primary)',
                      color: 'white',
                      fontSize: 25,
                    }}
                  />
                </div>
                <div className="flex self-end">
                  <div className={`text-buttom-2 font-medium cursor-pointer flex gap-2`}>
                    {
                      e.apps?.map(app => (
                        <Tooltip key={app.app} content={app.app}>
                          <div>
                            <MicroIcon {...app.icon} />
                          </div>
                        </Tooltip>
                      ))
                    }
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </div>
  )
};

export default observer(Listing);
